import { resetSubmit } from '@/store/slices/registrationSlice'
import { RegistrationPage } from '@/components'
import { initializeStore } from '@/store'
import { NextPage } from 'next'

const NextRegistrationPage: NextPage = () => {
  return (
      <RegistrationPage />
  )
}

NextRegistrationPage.getInitialProps = async () => {
  const reduxStore = initializeStore()
  const { dispatch } = reduxStore
  dispatch(resetSubmit())

  return {
    initialReduxState: reduxStore.getState(),
  }
}

export default NextRegistrationPage
